import { color, padding } from '@evrekadev/evreka-ui-components'
import { Flex } from 'components'
import styled from 'styled-components'

export const DividerStyled = styled.div`
  height: 100%;
  border-right: 0.5px solid ${color('grey300')};
`
export const LayoutListWrapper = styled(Flex)`
  height: 100vh;
`
export const LayoutListChildWrapper = styled.div<{
  'no-padding': boolean
}>`
  ${({ 'no-padding': noPadding }) => padding([noPadding ? 0 : 16])}
  flex-grow: 1;
  overflow: auto;
`
